<template>
  <div class="editor">
    <CloseButton @close="$emit('call-editor', 'close')" />
    <div class="-header">
      <div class="--title">
        <span>Text Book</span>
      </div>
      <span class="--subtitle">แก้ไขเอกสารประกอบการเรียน</span>
    </div>
    <div class="-body">
      <Block no-border>
        <InputBox
          label="ชื่อหนังสือ"
          :edata="newBook.bookName"
          prop="bookName"
          @input="handleInput"
        />
      </Block>

      <Block no-border>
        <InputBox
          label="รายละเอียด"
          :edata="newBook.bookDescription"
          prop="bookDescription"
          @input="handleInput"
        />
      </Block>
      <div class="--controllers">
        <vs-button @click="saveData">Save</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
  import Block from "@/components/common-ui/block/index.vue";
  import InputBox from "@/components/common-ui/forms/input-box/index.vue";
  import {updateCourseOutline} from "@/services/api/course-outline";
  import InternalEventBus from "../eventbus";

  export default {
    props: {
      mode: String,
      edata: Object,
    },
    components: {
      CloseButton: () => import("./editor-close"),
      Block,
      InputBox
    },
    data() {
    return {
      assessmentOptions: [{ id: "", title: "" }],
      newBook: {
        bookName: "",
        bookDescription: ""
      }
    }
  },
  methods: {
    loadData() {
      this.newBook = {
        bookName: this.edata['bookName' + this.edata.bookNo],
        bookDescription: this.edata['bookDescription' + this.edata.bookNo],
        bookPic: this.edata['bookPic' + this.edata.bookNo],
      };
      this.$forceUpdate();
    },
    async saveData() {
      let res = null;
      const newCourseOutline = { ...this.edata };
      newCourseOutline['bookName' + this.edata.bookNo] = this.newBook.bookName;
      newCourseOutline['bookDescription' + this.edata.bookNo] = this.newBook.bookDescription;
      newCourseOutline['bookPic' + this.edata.bookNo] = this.newBook.bookPic;

      res = await updateCourseOutline(newCourseOutline);

      InternalEventBus.$emit('FORECE_UPDATE');

      if (res) {
        this.$emit("call-editor", "close");
      }
    },
    handleInput({ prop, data }) {
      this.newBook[prop] = data;
      this.$forceUpdate();
    }
  },
  mounted() {
    this.loadData();
  },
}
</script>

<style lang="scss" scoped>
@import "common-scoped";

.editor {
  display: flex;
  flex-direction: column;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 80%;
    flex-direction: column;

    & .--controllers {
      margin-top: 20px;
    }
  }
}
</style>
